import { ReactNode } from '@tanstack/react-router';
import { twJoin } from 'tailwind-merge';
import { formatNumber } from '../../lib/formatters';

export const ColoredMetric: React.FC<{
  value: bigint | undefined;
  formatFn: (x: bigint | undefined) => ReactNode;
  className?: string;
  positiveClass?: string;
  negativeClass?: string;
}> = ({
  value,
  formatFn = formatNumber,
  className,
  positiveClass = 'text-contentGreen',
  negativeClass = 'text-contentRed',
}) => (
  <span
    className={twJoin(
      className,
      value !== undefined && (value >= 0n ? positiveClass : negativeClass)
    )}
  >
    {formatFn(value)}
  </span>
);
